import { render } from "./myPurchaseUndo.vue?vue&type=template&id=04df157a&scoped=true"
import script from "./myPurchaseUndo.vue?vue&type=script&lang=js"
export * from "./myPurchaseUndo.vue?vue&type=script&lang=js"

import "./myPurchaseUndo.vue?vue&type=style&index=0&id=04df157a&lang=less&scoped=true"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04df157a"]])

export default __exports__